import type { AuthEventProperties, UserEventProperties } from './types';

export interface RawUserFields {
  userLocations?: string[] | null | undefined;
  userPerms?: Record<string, Record<string, string[]>> | null | undefined;
  permissionLevel?: string | null | undefined;
  isWebview: boolean;
}

export interface RawAuthFields {
  userCountry?: string | null | undefined;
  userAudience?: string | null | undefined;
  userState?: string | null | undefined;
}

export const buildUserEventProperties = (
  raw: RawUserFields,
): UserEventProperties => ({
  user_locations: raw.userLocations ?? [],
  user_perms: raw.userPerms ?? {},
  permission_level: raw.permissionLevel?.toLowerCase() ?? '',
  is_webview: String(raw.isWebview),
});

export const buildAuthEventProperties = (
  raw: RawAuthFields,
): AuthEventProperties => ({
  user_country: raw.userCountry ?? '',
  user_audience: raw.userAudience ?? '',
  user_state: raw.userState ?? 'N/A',
});

export type NullFieldName =
  | 'user_locations'
  | 'user_perms'
  | 'permission_level'
  | 'user_country'
  | 'user_audience'
  | 'user_state';

export const detectNullFields = (
  raw: RawUserFields & RawAuthFields,
): NullFieldName[] => {
  const fields: NullFieldName[] = [];
  if (raw.userLocations == null) fields.push('user_locations');
  if (raw.userPerms == null) fields.push('user_perms');
  if (raw.permissionLevel == null) fields.push('permission_level');
  if (raw.userCountry == null) fields.push('user_country');
  if (raw.userAudience == null) fields.push('user_audience');
  if (raw.userState == null) fields.push('user_state');
  return fields;
};
